/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionUserInfo } from './SubscriptionUserInfo';
import {
    SubscriptionUserInfoFromJSON,
    SubscriptionUserInfoFromJSONTyped,
    SubscriptionUserInfoToJSON,
    SubscriptionUserInfoToJSONTyped,
} from './SubscriptionUserInfo';
import type { GetSubscriptionFlowStatePlanInfo } from './GetSubscriptionFlowStatePlanInfo';
import {
    GetSubscriptionFlowStatePlanInfoFromJSON,
    GetSubscriptionFlowStatePlanInfoFromJSONTyped,
    GetSubscriptionFlowStatePlanInfoToJSON,
    GetSubscriptionFlowStatePlanInfoToJSONTyped,
} from './GetSubscriptionFlowStatePlanInfo';
import type { SubscriptionUserAddress } from './SubscriptionUserAddress';
import {
    SubscriptionUserAddressFromJSON,
    SubscriptionUserAddressFromJSONTyped,
    SubscriptionUserAddressToJSON,
    SubscriptionUserAddressToJSONTyped,
} from './SubscriptionUserAddress';
import type { SubscriptionPaymentInfo } from './SubscriptionPaymentInfo';
import {
    SubscriptionPaymentInfoFromJSON,
    SubscriptionPaymentInfoFromJSONTyped,
    SubscriptionPaymentInfoToJSON,
    SubscriptionPaymentInfoToJSONTyped,
} from './SubscriptionPaymentInfo';

/**
 * 
 * @export
 * @interface GetSubscriptionFlowStateResponse
 */
export interface GetSubscriptionFlowStateResponse {
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStateResponse
     */
    status: string;
    /**
     * 
     * @type {GetSubscriptionFlowStatePlanInfo}
     * @memberof GetSubscriptionFlowStateResponse
     */
    planInfo: GetSubscriptionFlowStatePlanInfo;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStateResponse
     */
    userEmail: string;
    /**
     * 
     * @type {SubscriptionUserInfo}
     * @memberof GetSubscriptionFlowStateResponse
     */
    userInfo?: SubscriptionUserInfo | null;
    /**
     * 
     * @type {SubscriptionUserAddress}
     * @memberof GetSubscriptionFlowStateResponse
     */
    userAddress?: SubscriptionUserAddress | null;
    /**
     * 
     * @type {SubscriptionPaymentInfo}
     * @memberof GetSubscriptionFlowStateResponse
     */
    startSubscriptionPaymentData: SubscriptionPaymentInfo;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionFlowStateResponse
     */
    lastPaymentFailedReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionFlowStateResponse
     */
    acceptedTerms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionFlowStateResponse
     */
    creditCardRequired?: boolean;
}

/**
 * Check if a given object implements the GetSubscriptionFlowStateResponse interface.
 */
export function instanceOfGetSubscriptionFlowStateResponse(value: object): value is GetSubscriptionFlowStateResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('planInfo' in value) || value['planInfo'] === undefined) return false;
    if (!('userEmail' in value) || value['userEmail'] === undefined) return false;
    if (!('startSubscriptionPaymentData' in value) || value['startSubscriptionPaymentData'] === undefined) return false;
    if (!('acceptedTerms' in value) || value['acceptedTerms'] === undefined) return false;
    return true;
}

export function GetSubscriptionFlowStateResponseFromJSON(json: any): GetSubscriptionFlowStateResponse {
    return GetSubscriptionFlowStateResponseFromJSONTyped(json, false);
}

export function GetSubscriptionFlowStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionFlowStateResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'planInfo': GetSubscriptionFlowStatePlanInfoFromJSON(json['planInfo']),
        'userEmail': json['userEmail'],
        'userInfo': json['userInfo'] == null ? undefined : SubscriptionUserInfoFromJSON(json['userInfo']),
        'userAddress': json['userAddress'] == null ? undefined : SubscriptionUserAddressFromJSON(json['userAddress']),
        'startSubscriptionPaymentData': SubscriptionPaymentInfoFromJSON(json['startSubscriptionPaymentData']),
        'lastPaymentFailedReason': json['lastPaymentFailedReason'] == null ? undefined : json['lastPaymentFailedReason'],
        'acceptedTerms': json['acceptedTerms'],
        'creditCardRequired': json['creditCardRequired'] == null ? undefined : json['creditCardRequired'],
    };
}

export function GetSubscriptionFlowStateResponseToJSON(json: any): GetSubscriptionFlowStateResponse {
    return GetSubscriptionFlowStateResponseToJSONTyped(json, false);
}

export function GetSubscriptionFlowStateResponseToJSONTyped(value?: GetSubscriptionFlowStateResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'planInfo': GetSubscriptionFlowStatePlanInfoToJSON(value['planInfo']),
        'userEmail': value['userEmail'],
        'userInfo': SubscriptionUserInfoToJSON(value['userInfo']),
        'userAddress': SubscriptionUserAddressToJSON(value['userAddress']),
        'startSubscriptionPaymentData': SubscriptionPaymentInfoToJSON(value['startSubscriptionPaymentData']),
        'lastPaymentFailedReason': value['lastPaymentFailedReason'],
        'acceptedTerms': value['acceptedTerms'],
        'creditCardRequired': value['creditCardRequired'],
    };
}

